var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRateLittle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 29,
    rx: 5.5,
    fill: "#EF4444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 29,
    rx: 5.5,
    stroke: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4755 6.46353L18.9511 6.30902C18.6517 5.38771 17.3483 5.38771 17.0489 6.30902L17.5245 6.46353L17.0489 6.30902L15.3916 11.4098H10.0283C9.05955 11.4098 8.65678 12.6494 9.44049 13.2188L13.7795 16.3713L12.1221 21.4721C11.8228 22.3934 12.8773 23.1596 13.661 22.5902L18 19.4377L22.339 22.5902C23.1227 23.1596 24.1772 22.3934 23.8779 21.4721L22.2205 16.3713L26.5595 13.2188C27.3432 12.6494 26.9404 11.4098 25.9717 11.4098H20.6084L18.9511 6.30902L18.4755 6.46353Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateLittle);
export default __webpack_public_path__ + "static/media/Rate-Little.23ff270d416e3ec0dc78584de11efe7b.svg";
export { ForwardRef as ReactComponent };